import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Flex from 'components/ui/Flex';
import Radio from 'components/ui/Radio';
import Text from 'components/ui/Text';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import {
    selectAddress,
    selectCustomDeliveryAddressIsSet,
    selectSelectedCustomDeliveryAddress,
    standardAddressSet,
} from 'store/reducers/cartSlice';
import { ShopDeliveryAddress } from 'microshop-api';
import AsideSection from './AsideSection';
import { Valid } from './ValidIcon';

const CustomDeliveryAddresses = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const customDeliveryAddressIsSet = useAppSelector(selectCustomDeliveryAddressIsSet);
    const selectedCustomDeliveryAddress = useAppSelector(selectSelectedCustomDeliveryAddress);
    const address = useAppSelector(selectAddress);

    return (
        <AsideSection
            header={t('deliveryAddress', 'Delivery address')}
            validate
            valid={!!customDeliveryAddressIsSet ? Valid.Valid : Valid.Unknown}
        >
            <div>
                {selectedCustomDeliveryAddress && (
                    <DeliveryAddressField
                        address={selectedCustomDeliveryAddress}
                    />
                )}
                {(
                    <div className="mt-2 mb-2">
                        {address?.customDeliveryAddresses?.map((a, index) => {
                            return (
                                <Address
                                    index={index}
                                    key={index}
                                    addressClick={() => {
                                        dispatch(
                                            standardAddressSet({
                                                name: a?.name ?? '',
                                                address1: a?.address1 ?? '',
                                                address2: a?.address2 ?? '',
                                                city: a?.city ?? '',
                                                country: a?.country ?? '',
                                                postalCode: a?.postCode ?? '',
                                            }),
                                        );
                                    }}
                                    checked={address?.name === a?.name && address?.address1 === a?.address1}
                                    address={a}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </AsideSection>
    );
};

const DeliveryAddressField = ({
    address,
}: {
    address: ShopDeliveryAddress;
}) => {
    return (
        <>
            <Text uppercase className="f3-700">
                {address?.name}
            </Text>
            <Text light>
                {address?.address1}, {address?.postCode ?? address?.postCode} {address?.city}
            </Text>
        </>
    );
};

const Address = ({
    address,
    checked,
    index,
    addressClick,
}: {
    address: ShopDeliveryAddress;
    checked?: boolean;
    index: number;
    addressClick: () => void;
}) => {
    return (
        <AddressWrapper>
            <Flex align="center" className={'mb-3'} key={index} onClick={() => addressClick()}>
                <Radio onChange={() => null} checked={checked} />
                <div>
                    <Text fontSize={14} className="f3-700">
                        {address.name}
                    </Text>
                    <Text fontSize={14}>{address.address1}</Text>
                    {address.address2 && <Text fontSize={14}>{address.address2}</Text>}
                    <Text fontSize={14}>{address.city}</Text>
                    <Text fontSize={14}>{address.country}</Text>
                </div>
            </Flex>
        </AddressWrapper>
    );
};

export default CustomDeliveryAddresses;

const AddressWrapper = styled.div`
    cursor: pointer;
`;
